import { loadApplication } from 'src/slice';
import auth from 'src/auth';

export default function initializeApplication({ dispatch }) {
    if (auth.isLoggedIn()) {
        dispatch(loadApplication());
    }
}
